var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuoteinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 38,
  fill: "none",
  viewBox: "0 0 50 38"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#330DF2",
  d: "M27.48 38h20.04V17.53h-7.644C39.669 11.757 43.079 8.398 50 7.663L48.347 0C35.537.525 27.48 5.773 27.48 21.31zM0 38h20.145V17.53H12.5c-.31-5.773 2.996-9.132 10.02-9.867L20.972 0C8.058.525 0 5.773 0 21.31z"
})));
export default SvgQuoteinline;